import script from "./ModalWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ModalWindow.vue?vue&type=style&index=0&id=2abeab4e&lang=scss"

const __exports__ = script;

export default __exports__